import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useState } from 'react';

import type { CardRevealUIState } from './CardsReveal/types.ts';
import type { useCardPullUIState_cardPull } from './__generated__/useCardPullUIState.graphql.ts';

export const useCardPullUIState = ({
  initialCardPull,
}: {
  initialCardPull: Nullable<useCardPullUIState_cardPull>;
}) => {
  const initialState = ((): CardRevealUIState => {
    if (!initialCardPull) {
      return 'idle';
    }
    if (initialCardPull.activePulledCards.some(card => card.picked)) {
      return 'allRevealed';
    }
    return 'pulled';
  })();

  const [uiState, setUIState] = useState<CardRevealUIState>(initialState);
  return [uiState, setUIState] as const;
};

useCardPullUIState.fragments = {
  cardPull: gql`
    fragment useCardPullUIState_cardPull on CardPull {
      id
      activePulledCards {
        id
        picked
      }
    }
  ` as TypedDocumentNode<useCardPullUIState_cardPull>,
};
